"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PropTypes = require("prop-types");
var classnames_1 = require("../util/classnames");
var dom_helpers_1 = require("../util/dom-helpers");
var vdl_prefix_1 = require("../util/vdl-prefix");
var busy_icon_1 = require("./busy-icon");
var _1 = require("../util/_");
var BusyIndicator = /** @class */ (function (_super) {
    __extends(BusyIndicator, _super);
    function BusyIndicator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BusyIndicator.prototype.componentDidMount = function () {
        if (this.props.fullScreen) {
            dom_helpers_1.addClass(document.body, vdl_prefix_1.vdlPrefix('busy-indicator-open'));
        }
    };
    BusyIndicator.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.fullScreen && !prevProps.fullScreen) {
            dom_helpers_1.addClass(document.body, vdl_prefix_1.vdlPrefix('busy-indicator-open'));
        }
        else if (!this.props.fullScreen && prevProps.fullScreen) {
            dom_helpers_1.removeClass(document.body, vdl_prefix_1.vdlPrefix('busy-indicator-open'));
        }
    };
    BusyIndicator.prototype.componentWillUnmount = function () {
        if (this.props.fullScreen) {
            dom_helpers_1.removeClass(document.body, vdl_prefix_1.vdlPrefix('busy-indicator-open'));
        }
    };
    BusyIndicator.prototype.render = function () {
        var _a;
        var _b = this.props, className = _b.className, size = _b.size, overlay = _b.overlay, fullScreen = _b.fullScreen;
        var customProps = _1.omit(this.props, Object.keys(BusyIndicator.propTypes));
        var classes = (_a = {},
            _a[vdl_prefix_1.vdlPrefix('busy-indicator')] = true,
            _a[vdl_prefix_1.vdlPrefix('busy-indicator--overlay')] = overlay,
            _a[vdl_prefix_1.vdlPrefix('busy-indicator--full-screen')] = fullScreen,
            _a[vdl_prefix_1.vdlPrefix("busy-indicator--" + size)] = true,
            _a);
        return (React.createElement("div", __assign({}, customProps, { className: classnames_1.classNames(className, classes) }),
            React.createElement(busy_icon_1.BusyIcon, { size: size })));
    };
    BusyIndicator.propTypes = {
        size: PropTypes.oneOf(['sm', 'md', 'lg', 'xl']),
        overlay: PropTypes.bool,
        fullScreen: PropTypes.bool,
        className: PropTypes.string
    };
    BusyIndicator.defaultProps = {
        size: 'md',
        overlay: false,
        fullScreen: false
    };
    return BusyIndicator;
}(React.PureComponent));
exports.BusyIndicator = BusyIndicator;
